<style lang="less" scoped>
.list-container .list-content-div .list-header-title-div.title {
  line-height: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    font-size: 16px;
    font-weight: 400;
    color: #8f9bb3;
  }
  .el-button--default {
    width: 128px;
    height: 40px;
    border: 1px solid #bb87f3;
    border-radius: 5px;
    background-color: #fff;
    color: #bb87f3;
  }
  .el-button--primary {
    width: 128px;
    height: 40px;
  }
  .title-right {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb
        :bConfigList="pageConfig.detailBreadCrumb"
      ></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div title">
        <div v-if="!addUrl">发布活动</div>
        <div v-else>URL导入</div>
        <div class="title-right">
          <!-- <span style="margin-right:10px">编辑人:李阳 编辑时间:2020/014/12 10:24</span> -->
          <el-button class="btn" @click="handelBack">返 回</el-button>
          <el-button class="btn" @click="handelPreview">预 览</el-button>
          <el-button
            class="btn"
            @click="submitForm('ruleForm', '04', '保存草稿')"
            >存草稿</el-button
          >
          <el-button
            v-if="$store.state.editId"
            class="btn"
            @click="submitForm('ruleForm', activityStatus, '保存')"
            >保 存</el-button
          >
          <el-button
            class="btn"
            type="primary"
            @click="submitForm('ruleForm', '01', '发布')"
            >发 布</el-button
          >
        </div>
      </div>
      <div class="list-header-content">
        <p v-if="$store.state.editId" class="list-header-content-title">
          编辑
        </p>
        <p v-else class="list-header-content-title">添加</p>
        <!-- 发布内容 -->
        <el-form ref="ruleForm" :model="form" :rules="rules" label-width="80px">
          <el-form-item
            label="标题"
            prop="activityTitle"
            style="max-width:480px"
          >
            <el-input
              v-model="form.activityTitle"
              maxlength="40"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="!addUrl"
            label="正文"
            :prop="addUrl ? '' : 'activityText'"
            style="max-width:480px"
          >
            <div id="editor" style="width: 405px"></div>
          </el-form-item>
          <el-form-item
            v-if="addUrl"
            label="文章来源"
            :prop="addUrl ? 'activitySource' : ''"
            style="max-width:480px"
          >
            <el-input v-model="form.activitySource" show-word-limit></el-input>
          </el-form-item>
          <el-form-item
            label="URL"
            v-if="addUrl"
            :prop="addUrl ? 'activitySourceUrl' : ''"
            style="max-width:480px"
          >
            <el-input
              v-model="form.activitySourceUrl"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="分类" prop="typeCode" style="max-width:480px">
            <el-select
              v-model="form.typeCode"
              placeholder="分类"
              @change="changeTypeCode"
              style="width:100%"
            >
              <el-option
                v-for="(item, index) in categoryList"
                :key="index"
                :label="item.configName"
                :value="item.configVal"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="封面" prop="activityCover">
            <el-upload
              action="#"
              drag
              :class="{ hide: hideUpload }"
              :on-exceed="handleExceed"
              accept=".jpg,.png,.bmp,.jpeg,.gif"
              :http-request="handleVideoUpload"
              list-type="picture-card"
              :limit="1"
              :on-remove="handleRemove"
              :before-upload="handleVideoBeforeUpload"
              :on-preview="handlePictureCardPreview"
              :file-list="fileList"
            >
              <i class="el-icon-upload"></i>
              <p class="text">
                图片格式 bmp、jpeg、jpg、gif ，图片大小2M以内。 分辨率 1302*507
                像素及以下（图片比例为：18:9即可）
              </p>
            </el-upload>
          </el-form-item>

          <el-form-item
            label="定时发布"
            :prop="form.isTimingPublish ? 'activityPublishTime' : 'abs'"
            style="max-width:480px"
          >
            <el-date-picker
              v-if="form.isTimingPublish"
              style="width:90%"
              z-index="9"
              v-model="form.activityPublishTime"
              type="datetime"
              placeholder="选择日期时间"
              default-time="12:00:00"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
            <el-checkbox
              v-model="form.isTimingPublish"
              style="margin-left: 10px"
            ></el-checkbox>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 大图展示 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <!-- 手机展示 -->
    <phone
      ref="phone"
      :form="form"
      :showParentsSubmit="showParentsSubmit"
    ></phone>
  </div>
</template>

<script>
import pageConfig from './page-config'
import phone from '@/components/phone-preview/index.vue'
import E from 'wangeditor'

export default {
  components: { phone },
  data() {
      //验证规则
    var http = (rule, value, callback) => {
      const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/
      if (!reg.test(value)) {
        callback(new Error('请输入正确的网址'))
      } else {
        callback()
      }
    }
    var activityCover = (rule, value, callback) => {
      if (
        this.form.activityCover == '' ||
        this.form.activityCover == undefined
      ) {
        callback(new Error('请选择图片'))
      } else {
        callback()
      }
    }
    var activityText = (rule, value, callback) => {
      if (this.form.activityText == '' || this.form.activityText == undefined) {
        callback(new Error('请输入正文'))
      } else {
        callback()
      }
    }
    return {
      activityStatus: '', //当前页面状态
      dialogVisible: false, //图片弹窗
      categoryList: [], //活动类别
      dialogImageUrl: '', //大图地址
      showParentsSubmit: true, //是否显示立即发布的按钮
      addUrl: false, //判断是url还是活动添加
      pageConfig: pageConfig,
      form: {
        isTimingPublish: false, //定时发布
      },
      hideUpload: false,//上传图片按钮
      fileList: [], //封面图片地址
      editor: null, //富文本初始化
      rules: { //验证规格
        activityTitle: [
          { required: true, message: '请输入标题', trigger: 'blur' },
        ],
        activityText: [
          { required: true, validator: activityText, trigger: 'blur' },
        ],
        typeCode: [
          { required: true, message: '请选择分类', trigger: 'change' },
        ],
        activityCover: [
          { required: true, validator: activityCover, trigger: 'change' },
        ],
        activityPublishTime: [
          { required: true, message: '请选择发布时间', trigger: 'blur' },
        ],
        abs: [{}],
        activitySource: [
          { required: true, message: '请输入文章来源', trigger: 'blur' },
        ],
        activitySourceUrl: [
          {
            required: true,
            validator: http,
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {},
  watch: {},
  created() {
    this.init()
  },
  methods: {
    //   返回上一页
    handelBack() {
      // this.$router.back();
      let obj = {}
      obj.activityStatus = this.form.activityStatus
      this.$router.push({
        name: 'activityManagement',
        params: obj,
      })
    },
    //获取内容详情
    getFormInfo() {
      let id = this.$route.query.id
      let _ = this
      _.$H.get(_, _.$A.serviece.del + id).then((res) => {
        _.form = res.data.data
        if (_.form.activityCover != '') {
          _.hideUpload = true
          let obj = {}
          obj.url = _.form.activityCover
          _.fileList.push(obj)
        }
        if (_.form.isTimingPublish == 'Y') {
          _.form.isTimingPublish = true
        } else {
          _.form.isTimingPublish = false
        }
        _.editor.txt.html(_.form.activityText)
      })
    },
    // 选择活动分类
    changeTypeCode(e) {
      if (e == '01') {
        this.form.typeCodeName = '社区活动'
      } else if (e == '02') {
        this.form.typeCodeName = '行业资讯'
      } else if (e == '03') {
        this.form.typeCodeName = '官方发布'
      } else if (e == '04') {
        this.form.typeCodeName = '挚友分享'
      }
    },

    //手机预览
    handelPreview() {
      this.$refs.phone.goShow()
    },

    // 菜单列表
    init() {
      // 获取商品id
      if (this.$store.state.editId) {
        this.getFormInfo()
      }
      //判断是不是url导入页面
      if (this.$route.query.url) {
        this.addUrl = true
      }
      //判断活动的状态
      if (this.$route.query.activityStatus) {
        this.activityStatus = this.$route.query.activityStatus
      }
      let _ = this
      //活动类别
      _.$H
        .post(_, _.$A.config.list, { configType: '205', sort: '+configDisp' })
        .then((res) => {
          _.categoryList = res.data.data
        })
    },
//验证表单提交是否完整
    submitForm(ruleForm, val, text) {
      let _ = this
      if (val == '04') {
        _.$U.confirmDel(_, '确定是否' + text + '?', '取消', '确定', () => {
          _.submitUp(val)
        })
        return
      }
      _.$refs[ruleForm].validate((valid) => {
        if (valid) {
          _.$U.confirmDel(_, '确定是否' + text + '?', '取消', '确定', () => {
            _.submitUp(val)
          })
        } else {
          return false
        }
      })
    },

    // 表单提交
    submitUp(val) {
      if (!this.addUrl) {
        this.form.activitySource = '平台创建'
        this.form.activitySourceUrl = ''
      }
      if (this.form.isTimingPublish) {
        this.form.isTimingPublish = 'Y'
        this.form.activityStatus = '01'
        this.form.activityStatusName = '未发布'
      } else {
        this.form.isTimingPublish = 'N'
        this.form.activityStatus = '02'
        this.form.activityStatusName = '已发布'
        delete this.form.activityPublishTime
      }
      if (!this.$store.state.editId) {
        //添加
        if (val == '04') {
          this.form.activityStatus = '04'
          this.form.activityStatusName = '草稿'
        }
        let _ = this
        let obj = {}
        obj.activityStatus = _.form.activityStatus
        _.$H.post(_, _.$A.serviece.add, _.form).then((res) => {
          _.$U.confirmSure(_, '成功', () => {
            _.$router.push({
              name: 'activityManagement',
              params: obj,
            })
          })
        })
      } else {
        //编辑
        if (val == '04') {
          this.form.activityStatus = '04'
          this.form.activityStatusName = '草稿'
        }
        if (val == '03') {
          this.form.activityStatus = '03'
          this.form.activityStatusName = '已下架'
        }

        let _ = this
        //   fileForm = new FormData();
        // for (var i in _.form) {
        //   fileForm.append(i, _.form[i]);
        // }
        let obj = {}
        obj.activityStatus = _.form.activityStatus
        _.$H.post(_, _.$A.serviece.edit, _.form).then((res) => {
          _.$U.confirmSure(_, '成功', () => {
            _.$router.push({
              name: 'activityManagement',
              params: obj,
            })
          })
        })
      }
    },
    //删除图片
    handleRemove(file, fileList) {
      this.form.activityCover = ''
      this.fileList = []
      this.hideUpload = false
    },
    //预览图片或者文件
    handlePictureCardPreview(file) {
      // window.open(file.url);
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //限制上传文件
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`)
    },
    //限制文件大小
    handleVideoBeforeUpload(file) {
      let isLt102K = file.size / 1024 / 1024 / 5 < 1
      if (!isLt102K) {
        this.$message.error('上传文件大小不能超过5M!')
        return false
      }
    },
    //选择封面
    handleVideoUpload(file) {
      // this.form.file = file.file;
      let _ = this,
        formData = new FormData()
      formData.append('file', file.file)
      _.$H.postFormData(_, _.$A.serviece.upImage, formData).then((res) => {
        if (res.data.data) {
          _.form.activityCover = res.data.data.attachmentUrl
          _.hideUpload = true
          _.$refs.ruleForm.clearValidate('activityCover')
        } else {
          _.fileList = []
        }
      })
    },
    // 初始化富文本
    EditorCreate() {
      this.editor = new E('#editor')
      this.editor.config.menus = [
        // 菜单配置
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        'list', // 列表
        'justify', // 对齐方式
        'quote', // 引用
        'emoticon', // 表情
        'image', // 插入图片
        'table', // 表格
        'code', // 插入代码
        'undo', // 撤销
        'redo', // 重复
      ]
      this.editor.config.height = 600
      this.editor.config.pasteText = true // 只粘贴纯文本
      this.editor.config.zIndex = 100
      this.editor.config.uploadImgShowBase64 = false // 使用 base64 保存图片
      this.editor.config.uploadImgMaxSize = 3 * 1024 * 1024 //限制图片大小
      this.editor.config.uploadImgServer = this.$A.serviece.upImage //上传图片地址
      this.editor.config.uploadImgHeaders = {
        Authorization: this.$store.state.token, // 设置请求头
      }
      this.editor.config.uploadFileName = 'file' //设置字段
      this.editor.config.uploadImgMaxLength = 10 // 限制一次最多上传 5 张图片
      this.editor.config.uploadImgTimeout = 3 * 60 * 1000 // 设置超时时间
      // this.editor.config.uploadImgHooks = {
      //   // 图片上传并返回结果，但图片插入错误时触发
      //   fail: function(xhr, editor, result) {
      //     console.log(result);
      //   },
      //   success: function(xhr, editor, result) {
      //     // 图片上传并返回结果，图片插入成功之后触发
      //     console.log(result, "success");
      //   },
      // };
      this.editor.config.uploadImgHooks = {
        fail: (xhr, editor, result) => {
          // 插入图片失败回调
        },
        success: (xhr, editor, result) => {
          // 图片上传成功回调
        },
        timeout: (xhr, editor) => {
          // 网络超时的回调
        },
        error: (xhr, editor) => {
          // 图片上传错误的回调
        },
        customInsert: (insertImg, result, editor) => {
          // 图片上传成功，插入图片的回调
          //result为上传图片成功的时候返回的数据，这里我打印了一下发现后台返回的是data：[{url:"路径的形式"},...]

          let url = result.data.attachmentUrl
          insertImg(url)
          // }
        },
      }
      this.editor.config.onchange = (html) => {
        this.form.activityText = html // 绑定当前逐渐地值
      }

      this.editor.config.showLinkImg = false // 隐藏“网络图片”tab

      this.editor.create()
    },
  },
  mounted() {
    this.EditorCreate()
  },
}
</script>
